import { render } from "./JiZhan.vue?vue&type=template&id=d3ef96b6&scoped=true"
import script from "./JiZhan.vue?vue&type=script&lang=js"
export * from "./JiZhan.vue?vue&type=script&lang=js"

import "./JiZhan.vue?vue&type=style&index=0&id=d3ef96b6&scoped=true&lange=less&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ef96b6"]])

export default __exports__